import { motion } from "framer-motion";

export function FadeUp({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SplitLines({ lines, className = "", accentLast = false, delay = 0 }) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${accentLast && i === lines.length - 1 ? "text-[#FF5500]" : "text-white"}`}
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{
              duration: 0.9,
              delay: delay + i * 0.13,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p
      className={`font-telemetry text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#FF5500] ${className}`}
    >
      {children}
    </p>
  );
}
